export function initialsOf(name: string): string {
  const words: string[] = Array.from(name.matchAll(/\p{L}+/gu), (match) => match[0]);
  if (words.length === 0) return "?";
  const first = words[0].charAt(0);
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : "";
  return `${first}${last}`.toLocaleUpperCase();
}
